// removed by extract-text-webpack-plugin
module.exports = {"container":"page-header__container___3mHaO","title":"page-header__title___1wLp2","icon":"page-header__icon___2hQPa","toggle-navigation":"page-header__toggle-navigation___3Yn3t","button-back":"page-header__button-back___V20e4","icon-prev":"page-header__icon-prev___qmktb"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/PageHeader/page-header.scss
// module id = 942
// module chunks = 0